import React from 'react';
import { Grid, Header, Segment } from 'semantic-ui-react';

import PageWrap from './PageWrap';
import AppFeed from './AppFeed';
import withAuthorization from '../withAuthorization';

const HomePage = () => (
  <PageWrap>
    <Grid style={{ height: '100%' }} verticalAlign="middle" padded>
      <Grid.Column>
        <Segment padded="very">
          <Header as="h1" color="blue" style={{ marginBottom: '1.5em' }}>
            App List
          </Header>
          <AppFeed />
        </Segment>
      </Grid.Column>
    </Grid>
  </PageWrap>
);

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(HomePage);



// WEBPACK FOOTER //
// ./src/components/Home.jsx